import React from 'react';
import { createPortal } from 'react-dom';
/**
 * @deprecated - Please use the appropriate Toolkit component directly per your use case (i.e. Modal, Popover etc)
 * {@link https://frontend-ds.cko-dev.ckotech.co/?path=/docs/modal--docs}
  * {@link https://frontend-ds.cko-dev.ckotech.co/?path=/docs/popover--docs}
 */
export const Portal = (props) => {
    const { children, forwardRef, as, ...rest } = props;
    if (!as) {
        return createPortal(children, document.body);
    }
    const portalProps = {
        'data-testid': 'portal',
        ref: forwardRef,
        ...rest,
    };
    return createPortal(React.createElement(as, portalProps, children), document.body);
};
